export const maskApiKey = (apiKey, visibleStart = 4, visibleEnd = 4) => {
  if (!apiKey) return "";

  if (apiKey.length <= visibleStart + visibleEnd) {
    return apiKey;
  }

  const start = apiKey.slice(0, visibleStart);
  const end = apiKey.slice(-visibleEnd);
  const maskedLength = 3;
  const mask = ".".repeat(maskedLength);

  return `${start}${mask}${end}`;
};
